import React from 'react';
import {inject, observer} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {Button, ButtonToolbar, Row, Col, ControlLabel ,FormGroup, FormControl, Media, Tabs, Tab} from 'react-bootstrap';
import AttachmentsForm from  '../common_components/attachments/AttachmentsForm';
import TextareaAutosize from 'react-autosize-textarea';

@injectIntl @inject('rootStore','feedbackChainsStore', 'feedbackCommentsStore' ) @observer
export default class CommentForm extends React.Component {

    constructor(props){
        super(props);
        this.handleChangeComment = this.handleChangeComment.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    render(){
        let currentUser = this.props.rootStore.user;
        const {comment, intl} = this.props;
        const isNewComment = !comment.persisted;
        return(
            <Media className={"feedback-comment-form"}>
                <Media.Left>
                    <div className={"img-thumbnail img-circle"}>
                        <img className="img-responsive" src={currentUser.profilePhotoUrl}
                             alt={currentUser.name+" thumbnail"}/>
                    </div>
                    <div className="creator-name" > {currentUser.name} </div>
                </Media.Left>
                <Media.Body>
                    <Row>
                        <Col xs={12} md={12} className={'feedback-body-container'}>
                            <FormGroup
                                controlId="formBasicText"
                            >
                                { isNewComment && <ControlLabel>{intl.formatMessage({id: "new_comment_title"})}</ControlLabel> }
                                { this.props.rootStore.currentUserBelongsToStartup() && <CommentType comment={comment} /> }
                                <TextareaAutosize
                                    className="editable-text-area form-control"
                                    value={comment.description}
                                    placeholder={intl.formatMessage({id: "comment_placeholder"})}
                                    onChange={this.handleChangeComment}
                                    rows={3}
                                />
                                <AttachmentsForm attachable={comment} />
                                <div>
                                    <ButtonToolbar>
                                        <Button className={'pull-right'} bsStyle={"primary"} onClick={this.handleButtonClick} >
                                            { comment.isEditing ? intl.formatMessage({id: "save_comment"}) : intl.formatMessage({id: "add_comment"}) }
                                        </Button>
                                        { comment.persisted && 
                                            <Button className={'pull-right'} bsStyle={"default"} onClick={() =>{
                                                comment.cancelEditing()}
                                            }>
                                                { intl.formatMessage({id: "cancel"})}
                                            </Button>
                                        }
                                    </ButtonToolbar>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                </Media.Body>
            </Media>
        );
    }


    handleChangeComment(e){
        this.props.comment.description = e.target.value;
    }

    handleButtonClick(){
        const {comment} = this.props;
        if( !comment.persisted ){
            comment.persist();
        }
        else{
            comment.setIsEditing(false);
        }
    }

}


@injectIntl @observer
class CommentType extends React.Component{

    render(){
        const {intl, comment} = this.props;
        const activeKey = comment.internal ? 'internal' : 'public';
        return(
            <Tabs activeKey={activeKey}
                  id="uncontrolled-tab-example"
                  className={'comment-internal-tabs'}
                  onSelect={this.handleInternalSelect}
            >
                <Tab eventKey={'public'} title={intl.formatMessage({id: "public_comment_title"})}>
                    <div className={'small text-muted'}>{intl.formatMessage({id: "public_comment_description"})}</div>
                </Tab>
                <Tab eventKey={'internal'} title={intl.formatMessage({id: "internal_comment_title"})}>
                    <div className={'small text-muted'}>{intl.formatMessage({id: "internal_comment_description"})}</div>
                </Tab>
            </Tabs>            
        )
    }

    handleInternalSelect = (k) => {
        const {comment} = this.props;
        if( k == 'internal' ) {
            comment.setInternal(true);
        }
        else {
            comment.setInternal(false);
        }
    }
}